export default {
  paddingTop: '1.2em',
  paddingTopDesktop: '4em',
  marginTop: '0',
  linkPadding: '0.1rem 0',
  fontSize: '0.9rem',
  titleFontSize: '0.9rem',
  infoPaddingTop: '1rem',
  textDecoration: 'none',
  pTagColor: 'var(--black)',
  columnMarginTop: '2rem',
  footerTextMarginTop: '1.5rem',
  fontWeightTitle: 'bold',
  backgroundColor: 'var(--sg-grey-200)',
  linkColor: 'var(--black)',
  textColor: 'var(--omalaina-bright-orange)',
  fontFamily: 'var(--font-family)',
  logoSize: '9.4rem',
  columnsPaddingTopMobile: '3rem',
};
